var _defs, _g, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInformationConsultantsV1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1d1d1b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_information_consultants_v1.2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "52.14 21.73 52.14 14.34 46.24 14.34 46.24 26.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.33 52.64 41.33 31.1 36.91 34.94 62.02 13.15 86.89 34.94 82.58 31.17 82.58 52.64"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.07,84,15.23,70.36,29,52.35a69.89,69.89,0,0,0,5.83,4.39c1.75,1,5.47,2.86,7.47,2.93,2.61.1,7.49-1.48,10.1-1.53a49.24,49.24,0,0,1,7.32,1.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.61,85l21.56-18.33L97.26,49.08l-10.9,8.86-6.79.84S70.4,57.39,66.43,58a19,19,0,0,0-7.27,3.2L47,75.81c.35,2.08,4.42,4.48,8.34,3.23,4.42-1.42,12.22-9.94,12.22-9.94l9.09.36L91.81,89.14c.75,1.07,1.16,2.47-1.41,4.41a5.27,5.27,0,0,1-5,1L78.22,86.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.31,91.17l6.26,7.59S82,100,84,98.26a5,5,0,0,0,1.38-3.74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.13,96.81l6.18,6.89s3.13.82,5.29-.88c1.78-1.41,1-4.06,1-4.06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.73,103.71l3.78,4a4.11,4.11,0,0,0,4.41-1c1.93-1.7,1-4.49,1-4.49"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.08,
    y: 87.44,
    width: 16.41,
    height: 8.02,
    rx: 4.01,
    transform: "translate(-52.4 60.2) rotate(-46.25)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.58,
    y: 82.57,
    width: 14.53,
    height: 8.02,
    rx: 3.96,
    transform: "translate(-50.86 54.04) rotate(-46.25)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.18,
    y: 99.42,
    width: 14.53,
    height: 8.02,
    rx: 3.96,
    transform: "translate(-57.61 71.95) rotate(-46.25)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.94,
    y: 92.84,
    width: 17.4,
    height: 8.02,
    rx: 4.01,
    transform: "translate(-54.34 66.45) rotate(-46.25)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformationConsultantsV1);
export default __webpack_public_path__ + "static/media/icon_information_consultants_v1.39f15f97cbf3596c06a2364347802549.svg";
export { ForwardRef as ReactComponent };